import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="media-type"
//
// A media catalog track carries either an audio or a video source, never both,
// so the form shows only the fields of the selected type. The model enforces
// the same rule -- this only keeps the admin from uploading a file that would
// be rejected on save.
//
// The target names are the ones Avo generates for every field of a resource
// that declares a Stimulus controller ("<field><Type>Input" / "Wrapper"):
// a custom data-media-type-target is overwritten by the generated one.
export default class extends Controller {
  static targets = ["mediaTypeSelectInput", "rawAudioFileWrapper", "rawVideoFileWrapper"]

  connect() {
    this.toggle()
  }

  // Only a form has a media type select. The show screen renders the field that
  // belongs to the track and nothing else, so there is nothing to toggle there.
  toggle() {
    const select = this.select
    if (!select) return

    const video = select.value === "video"

    this.audioWrappers.forEach(wrapper => this.setVisible(wrapper, !video))
    this.videoWrappers.forEach(wrapper => this.setVisible(wrapper, video))
  }

  // Avo only renders the targets on some views, so every lookup falls back to
  // the markup that is always there.
  get select() {
    if (this.hasMediaTypeSelectInputTarget) return this.mediaTypeSelectInputTarget

    return this.element.querySelector('select[name$="[media_type]"]')
  }

  get audioWrappers() {
    if (this.hasRawAudioFileWrapperTarget) return this.rawAudioFileWrapperTargets

    return Array.from(this.element.querySelectorAll('[data-field-id="raw_audio"]'))
  }

  get videoWrappers() {
    if (this.hasRawVideoFileWrapperTarget) return this.rawVideoFileWrapperTargets

    return Array.from(this.element.querySelectorAll('[data-field-id="raw_video"]'))
  }

  // Avo's admin styles are separate from the app's, so toggle the style
  // directly instead of relying on a utility class being available here.
  setVisible(wrapper, visible) {
    wrapper.style.display = visible ? "" : "none"
  }
}
